import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScVIPCard = styled.div`
  border-radius: 20px;
  background: linear-gradient(341deg, #3f005c -10.86%, #a41a8b 95.6%);
  padding: 11px 50px 18px;

  @media (${device.mobile}) {
    padding: 11px 24px 18px;
  }

  & > .content {
    display: grid;
    gap: 64px;
  }
`;

export const ScVIPItem = styled.div<{ borderColor: string }>`
  position: relative;
  overflow: visible;

  & > img {
    position: absolute;
    top: -56px;
    left: 50%;
    transform: translateX(-50%);
    max-width: none;
  }

  & > .vip-item__content {
    position: relative;
    padding: 4px 16px;
    border-radius: 12px;
    border: 2px solid ${({ borderColor }) => borderColor};
    background-color: rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(6px);

    & > .divider {
      height: 1px;
      border-radius: 2px;
      background-color: #323444;

      &:last-of-type {
        display: none;
      }
    }

    & > .text {
      font-family: 'Open Sans';
      font-size: 13px;
      font-weight: 700;
      line-height: 20px;
      letter-spacing: 0;
      column-gap: 8px;
      padding-block: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &.fr-CA {
        font-size: 12px;
      }
    }
  }
`;
